import { IconCloseBig } from 'icons/components/IconCloseBig'
import Image from 'next/image'
import { cx } from 'utils/cx'

import styles from './ColorItem.module.scss'

const DEFAULT_SIZE = 16
const CONTAINER_PADDING = 4

export interface ColorItemProps {
	imageAlt: string
	imageSrc: string
	bordered?: boolean
	disabled?: boolean
	size?: number
	className?: string
}

export function ColorItem({
	bordered,
	disabled,
	imageSrc,
	imageAlt,
	className,
	size = DEFAULT_SIZE,
}: ColorItemProps): React.ReactNode {
	const sizeWithPadding = size + CONTAINER_PADDING

	return (
		<div
			style={
				{
					'--color-item-size': sizeWithPadding,
				} as React.CSSProperties
			}
			className={cx(
				styles.colorItem,
				bordered && styles.colorItemBordered,
				className
			)}
		>
			<Image
				src={imageSrc}
				alt={imageAlt}
				className={cx(styles.image, disabled && styles.disabled)}
				width={size}
				height={size}
				priority
			/>
			{disabled && (
				<IconCloseBig
					width={sizeWithPadding}
					height={sizeWithPadding}
					className={styles.crossIcon}
				/>
			)}
		</div>
	)
}
